import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function printRadParticipantPli(input: {
  id: number
  participantId: number
  templates: string[]
}) {
  const { id, participantId, templates } = input
  return restApiClient
    .url(constructApiUrl(API.rads.printParticipantPli.url, { id, participantId }))
    .post({ templates })
}
